var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-table-main"},[_c('div',{staticClass:"flex-table xc-table-linkage"},[_c('div',{staticClass:"xc-table-linkage-thead"},[_vm._t("flex-table-thead")],2),_vm._v(" "),_c('div',{staticClass:"xc-table-linkage-tbody"},[_vm._t("flex-table-box")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }